import styled from 'styled-components';

export const Svg = styled.svg`
  width: 25px;
  height: 25px;
`;

export const AnimatedPath = styled.path<{ $isExpanded: boolean }>`
  transition: transform 0.3s;
  transform-origin: center;
  transform: ${({ $isExpanded }) => ($isExpanded ? 'scale(0)' : 'scale(1)')};
`;
